/* Riot v7.1.0, @license MIT */
/** @type {string} current riot version */
const version = 'v7.1.0';

export { version };
